module.exports = __webpack_public_path__ + "media/images/favicon-0803493105dea610ac2755285b360ed4.ico";